exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-quote-details-modal span{display:block}.c-quote-details-modal_review-quote-button{margin-top:30px}", ""]);

// exports
